import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Decanter: Site = {
  id: 'decanter',
  logo: 'decanter.png',
  label: 'Decanter',
  analyticsName: 'decanter',
  hostname: 'decanter.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
